// extracted by mini-css-extract-plugin
module.exports = {"vTopNavHeight":"60px","logoImageWrap":"Logo_logoImageWrap__3i7Fj","logoImage":"Logo_logoImage__DBCd5"};